const baseUrl = "https://api.phyathai2.plaping-dc.com"
// const baseUrl = "http://localhost:8009"
const pageSize = 10
const dashboardUrl = "https://datastudio.google.com/embed/reporting/50b64fd9-ee26-40c1-ae47-c38fa1b86d22/page/vAiTC";
const version = "1.3.0";

export {
  baseUrl, pageSize, dashboardUrl, version
}
